import {Component, Input} from '@angular/core';
import {CustomSnackbarComponent} from "../../../../shared/components/custom-snackbar/custom-snackbar.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-badge-mail',
  templateUrl: './custom-sources-badge-mail.component.html',
  styleUrls: ['./custom-sources-badge-mail.component.scss']
})
export class CustomSourcesBadgeMailComponent {
  @Input() public datasource: DatasetUsageComponentObject;

  constructor(
    private readonly _snackbar: MatSnackBar,
    private readonly _translateService: TranslateService
  ) {
  }

  public onClipboard(): void {
    this._snackbar.openFromComponent(CustomSnackbarComponent, {
      duration: 10000,
      data: {
        message: this._translateService.instant('button.copied')
      }
    });
  }

}
